// Layers for what renders in a portal, lowest first. The DS Drawer paints its backdrop at 40 and its
// panel at 50, and the floorplan v2 editor lifts its offer drawers to 70 so they clear its own
// drawers. Anything a drawer opens in a portal has to outrank 70, or it lands behind the
// panel that opened it. Toasts go on top of everything: they can fire while any of these is open.
export const DRAWER_BACKDROP_Z_INDEX = 40;
export const DRAWER_PANEL_Z_INDEX = 50;
export const LIFTED_DRAWER_Z_INDEX = 70;
export const DRAWER_OVERLAY_Z_INDEX = 80;
export const POPOVER_Z_INDEX = 90;
export const TOAST_Z_INDEX = 100;

// Tailwind only generates the classes it finds spelled out, so these stay literals; a test pins them
// to the numbers above.
export const DRAWER_BACKDROP_Z_CLASS = 'z-40';
export const DRAWER_PANEL_Z_CLASS = 'z-50';
export const LIFTED_DRAWER_Z_CLASS = 'z-70';
export const POPOVER_Z_CLASS = 'z-90';
export const TOAST_Z_CLASS = 'z-100';
